export const SHOW_INSTANT_CASHOUT_PLAN = {
    EG: true,
    SA: false
  };
  